import React from 'react'

const avatars = {
  'Lisa Blatter': require('../main/lisa_blatter.jpg'),
  'Lisa Brühlmann': require('../main/lisa_bruehlmann.jpg'),
  'Eva Vitija': require('../main/eva_vitija.jpg'),
  'Corina Schwingruber Ilić': require('../main/corina_schwingruber_ilic.jpg'),
  'Anna Thommen': require('../main/anna_thommen.jpg')
}

export default function answer (props) {
  return (
    <div className='item answer'>
      <img className='ui avatar image'
        src={avatars[props.who]} />
      <div className='content'>
        <div className='header'>{props.who}</div>
        <div className='description'>
          {props.children}
        </div>
      </div>
    </div>
  )
}

answer.propTypes = {
  who: React.PropTypes.oneOf(['Lisa Blatter', 'Lisa Brühlmann', 'Eva Vitija', 'Corina Schwingruber Ilić', 'Anna Thommen']).isRequired,
  children: React.PropTypes.node
}



// WEBPACK FOOTER //
// ./src/components/answer/index.js